    import React, { useState, useEffect } from 'react';
    import { Button } from 'react-bootstrap';
    import "../../MainPage.css";

    function ScrollToTopButton() {
      const [isVisible, setIsVisible] = useState(false);

      const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      };

      // Scroll to top
      const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      };

      useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
          window.removeEventListener('scroll', toggleVisibility);
        };
      }, []);

      return (
        <>
            <Button
                onClick={scrollToTop}
                className="scroll-to-top-button"
                style={{right: isVisible ? '20px' : '-40px'}}
            >⮝</Button>
        </>
      );
    }

    export default ScrollToTopButton;